<div data-sessionExpiryDialogComponent>
  <h1 id="session-expiry-title" mat-dialog-title class="h1 h1--component-title">{{ "dialog.title.session.expiry" | translate | async }}</h1>

  <div id="session-expiry-description" mat-dialog-content>
    <p>{{ "dialog.session.expiry.intro" | translate | async }}</p>
    <p class="session-expiry-countdown" aria-hidden="true">{{ (data.countdown$ | async) | secondsToTimePipe }}</p>
    <span class="visually-hidden">{{ data.openingDuration }}</span>
    <p>{{ "dialog.session.expiry.body" | translate | async }}</p>
  </div>

  <div mat-dialog-actions class="flex flex--end-vertical">
    <div class="flex-child flex-child--flex-shrink">
      <button type="button" class="button button--green-secondary" mat-stroked-button (click)="signOut()">
        {{ "dialog.action.signout" | translate | async }}
      </button>
    </div>

    <div class="flex-child flex-child--flex-shrink">
      <button id="session-expiry-continue" type="button" class="button button--green-primary" mat-stroked-button (click)="continueSession()" cdkFocusInitial>
        {{ "dialog.action.continue.session" | translate | async }}
      </button>
    </div>
  </div>

  <span class="visually-hidden" role="status" aria-atomic="true">{{ announcement$ | async }}</span>
</div>
